import GenerateCodes from './js/generate-codes.js';
import './js/uo-codes-admin.js';
import './js/woo-product-uncanny-codes.js';

import './scss/main.scss';

// Do on DOM ready
document.addEventListener( 'DOMContentLoaded', () => {
	new GenerateCodes();
});